import React from "react";
import dashboard from "../../../images/dashboard.svg";
const Dashboard = () => {
  return (
    <div>
      <div className="flex flex-col gap-2 items-center p-10">
        <p className="text-sm text-primary bg-[#E6FEF2] rounded-full px-3 py-1 font-semibold">
          What's More
        </p>
        <h3 className="text-3xl font-bold text-black">The Dashboard</h3>
        <p className="text-accent font-semibold text-center">
          Control everything from our well-designed, secure and complete
          dashboard-easily
        </p>
      </div>
      <div>
        <img src={dashboard} alt="" />
      </div>
    </div>
  );
};

export default Dashboard;
